// Helper to derive a URL-friendly anchor slug from a section title.
// Mirrors the admin logic in BlocksTab.jsx so anchors stay consistent
// between admin "copy link" and public render.
export const slugifyAnchor = (s = '') =>
  s.toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .slice(0, 60);

export const getSectionAnchor = (section) =>
  section.anchor || slugifyAnchor(section.title || '') || section.id;
